import { render } from "./AdminDashboard.vue?vue&type=template&id=0ea8aad3&lang=pug"
const script = {}

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__